/**
 * FlexiPage Theme
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license Commercial
 */
"use strict";
var util_1 = require('./util');
var bindMenuOpen = function (btnEl) {
    var menuEl = document.getElementById(btnEl.getAttribute('data-menu-id'));
    if (!menuEl)
        throw new Error("Target menu element not found.");
    btnEl.addEventListener("click", function () {
        menuEl.classList.add('opened');
    });
};
var bindMenuClose = function (btnEl) {
    var menuEl = document.getElementById(btnEl.getAttribute('data-menu-id'));
    if (!menuEl)
        throw new Error("Target menu element not found.");
    btnEl.addEventListener("click", function () {
        menuEl.classList.remove('opened');
    });
};
function bindMenuElements() {
    var navOpen = document.body.querySelectorAll(".menu-open");
    var navClose = document.body.querySelectorAll(".menu-close");
    for (var i = 0; i < navOpen.length; i++)
        bindMenuOpen(navOpen.item(i));
    for (var i = 0; i < navClose.length; i++)
        bindMenuClose(navClose.item(i));
}
exports.bindMenuElements = bindMenuElements;
;
function bindAnchorNav() {
    var handleNav = function (anchor, cb) {
        if (cb === void 0) { cb = null; }
        if (anchor.length > 0) {
            //Parse parts
            var parts = anchor.split(":");
            var targetId = parts.shift();
            var targetEl = document.getElementById(targetId);
            if (!targetEl)
                return;
            //Parse setters
            for (var i = 0; i < parts.length; i++) {
                var args = parts[i].split("=", 2);
                var input = targetEl.querySelector('*[name*="' + args[0] + '"]');
                if (input)
                    input.value = args[1];
            }
            util_1.scrollToElement(targetEl, 300, -69, cb);
        }
    };
    var handleHash = function () {
        handleNav(location.hash.substr(1));
    };
    var bindLink = function (linkEl) {
        linkEl.addEventListener("click", function (ev) {
            ev.preventDefault();
            var anchorPos = linkEl.href.indexOf("#");
            var anchor = linkEl.href.substr(anchorPos + 1);
            handleNav(anchor, function () {
                var scroll = document.body.scrollTop || document.documentElement.scrollTop;
                location.href = linkEl.href;
                document.body.scrollTop = scroll;
                document.documentElement.scrollTop = scroll;
            });
            return false;
        });
    };
    window.onhashchange = handleHash;
    var links = document.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < links.length; i++)
        bindLink(links.item(i));
    setTimeout(function () {
        handleHash();
    }, 200);
}
exports.bindAnchorNav = bindAnchorNav;
;



/*****************
 ** WEBPACK FOOTER
 ** ./ts/nav.ts
 ** module id = 1
 ** module chunks = 0
 **/